
const digest = '489df21097791d16a6b7dc72995178b28e59eb9209286b9d6a1bdae7b608f0bb';
const classes = {"wrapper":"_wrapper_1jl1c_1","danger":"_danger_1jl1c_11","warning":"_warning_1jl1c_15"};
const css = `._wrapper_1jl1c_1 {
  font-family: Rubik, "sans-serif";
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  background-color: #619612;
  padding: 2px 6px 1px 6px;
  border-radius: 4px;
}

._danger_1jl1c_11 {
  background-color: #d81616;
}

._warning_1jl1c_15 {
  background-color: #ff9d2a;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  